// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"498be428","145":"6651d502","161":"d447f84c","553":"8f637e5f","686":"23d61bc4"}[chunkId] + ".chunk.css";
};